<template>
  <div id="PreTransport">
    <b-navbar type="light" variant="light-success">
      <b-button v-b-toggle.sidemenu variant="outline-secondary" class="mr-2 d-lg-none"><f-icon icon="bars"></f-icon></b-button>
      <b-navbar-brand  class="mb-0" :to="{ path: '/ld' }" replace>
        <img :src="logoImg" class="d-inline-block align-top" alt="Logo" height="30px">
        {{ logoName }}
      </b-navbar-brand>
    </b-navbar>
    <b-sidebar id="sidemenu" title="Menu" body-class="px-2" shadow>
      <left-menu></left-menu>
    </b-sidebar>
    <b-container fluid class="bg-white shadow-sm">
      <b-row>
        <b-col cols="3" class="d-none d-lg-block pb-4 pt-2">

          <left-menu></left-menu>
        </b-col>
        <b-col lg="9" class="pt-4 pb-4 animate__animated animate__fadeIn">
          <h2>แนบบิลขนส่งภายในจีน</h2>

          <b-card bg-variant="light" class="mb-3">
            <b-row>
              <b-col lg="6"><h4>เลือกรายการข้อมูลพรีออร์เดอร์ที่ร้านจีนทำการจัดส่ง</h4></b-col>
              <b-col lg="6">
                <b-form inline>
                  <b-form-input id="inline-form-input-pre-id" class="mb-2 mr-2" placeholder="รหัสพรีออร์เดอร์"></b-form-input>

                  <b-input-group class="mb-2 mr-2">
                    <b-form-input id="inline-form-input-usercode" placeholder="รหัสสมาชิก"></b-form-input>
                    <b-input-group-append>
                      <b-button variant="success">ค้นหา</b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form>
              </b-col>
            </b-row>

            <b-row>
              <b-col>
                <b-table striped responsive outlined small
                  :items="items" :fields="fields"

                  head-variant="light"
                  table-variant="light"

                  select-mode="single"
                  ref="selectInvoice"
                  selectable
                  @row-selected="onInvoiceSelected"
                  :busy="!dataReady"
                  class="table-mini">

                  <template #head(selected)=" {} ">

                  </template>

                  <template #cell(selected)="data">
                    <template v-if="data.rowSelected">
                      <f-icon icon="dot-circle" class="text-purple animate__animated animate__tada"></f-icon>
                    </template>
                    <template v-else>
                      <f-icon icon="circle"></f-icon>
                    </template>
                  </template>
                </b-table>
              </b-col>
            </b-row>
          </b-card>

          <b-card bg-variant="light" class="mb-3">
            <h4>รายละเอียดบิลขนส่ง</h4>
            <b-row>
              <b-col>

                <div class="mb-1">หลักฐานบิลขนส่ง:</div>
                <b-form-file v-model="fileimg" ref="file-input-img"
                  @input="uploadFile()" browse-text="เลือกไฟล์" accept="image/*"
                  drop-placeholder="แนบไฟล์บิลขนส่ง" placeholder="แนบไฟล์บิลขนส่ง"
                  class="mb-3"></b-form-file>

                <b-img thumbnail fluid width="350" center :src="form.pictureSlip" v-if="form.pictureSlip" alt="หลักฐานบิลขนส่ง"></b-img>

                <label for="pre_tran_remark" class="mb-1">หมายเหตุ:</label>
                <b-form-input id="pre_tran_remark"  class="mb-2" autocomplete="off" v-model="form.amountDelivery" type="text"></b-form-input>

              </b-col>
            </b-row>
          </b-card>



          <hr>

          <div class="text-center mt-2">
            <b-button variant="purple" size="lg" @click="onSubmit()" v-if="dataReady" :disabled="form.deliverDoc === ''">
              <f-icon icon="receipt"></f-icon>
              แจ้งชำระเงิน
            </b-button>
          </div>
        </b-col>
      </b-row>
    </b-container>
    <b-container fluid class="text-center mt-3 mb-2">
      {{ footerLC }}
    </b-container>
  </div>
</template>

<script>
import axios from "axios"; // api
import MenuBar from '@/components/Menubar' // เมนู
export default {
  name: "PreTransport",
  components: {
    'left-menu': MenuBar,
    // 'alert-card': AlertCard
  },
  beforeCreate() {
    // เหตุการจะเกิดขึ้นก่อนที่ Component จะถูก render เข้าไปใน DOM
    // this.$liff.init({ liffId: this.$liff_register_profile }, function (data) {})
  },
  created() {
    // ทุกอย่างจะถูกเตรียมไว้ครบหมดแล้ว และสามารถเข้าถึงได้หมด
    // setInterval(this.getDataMap, 1000)
  },
  async mounted() {
    // จะเกิดขึ้นเมื่อ DOM ถูกสร้างเสร็จแล้ว เราสามารถ เข้าถึง Element ต่างๆใน DOM ได้ทั้งหมด
    // เช่นการ ดึงข้อมูลจาก input เป็นต้น

    // this.getDateNow()
    this.getDataUser()
    await this.getDataInvoices()
  },
  data() {
    return {
      fields: [
        'selected',
        { key: 'deliverDoc', label: 'รหัสใบชำระสินค้า', thClass: 'py-2' },
        { key: 'userCode', label: 'รหัสสมาชิก', thClass: 'py-2 text-center', tdClass: 'text-center font-weight-bold' },
        { key: 'transportType', label: 'ประเภทการจัดส่ง', thClass: 'py-2 text-center' },
        { key: 'remark', label: 'หมายเหตุ', thClass: 'py-2 text-center', tdClass: 'font-weight-light' },
        { key: 'amountPaid', label: 'ราคารวม', thClass: 'py-2 text-center' },
        { key: 'status', label: 'สถานะ', thClass: 'py-2 text-center', tdClass: 'text-center font-weight-bold' },
      ],
      items: [],
      userData: {
        userName: '',
        firstName: '',
        lastName: '',
        telephoneNumber: '',
        userType: ''
      },
      priceDelivery: 0,
      // priceReturn: 0,
      form: {
        // TransportDate: "",
        amountDelivery:  "",
        pictureSlip: "",
        deliverDoc: "",
        // amountReturn: "",
        userName: "",
        LAST_USER: "",
        status: "จัดส่งสำเร็จ",
      },
      fileimg: null,
      dataReady: false,
    };
  },
  methods: {
    getDateNow () {
      let dateTime = this.getNowGlobal().split(' ')
      this.form.TransportDate = dateTime[0]
    },
    formatDate (strDate) {
      if (strDate) {
        var dtDate = strDate.split(' ')[0]
        var strDateShort = dtDate.split('-')[2] + '/' + dtDate.split('-')[1] + '/' + dtDate.split('-')[0]
        return strDateShort
      } else {
        return ''
      }
    },
    getDataUser() {
      let lsUser = this.getDataStorageUser()
      if (lsUser) {
        this.userData = lsUser

        this.form.LAST_USER = this.userData.userName
        this.form.userName = this.userData.userName
        // this.form.userCode = this.userData.userCode
      } else {
        this.$router.push('/Login')
      }
    },
    getDataInvoices () {
      this.dataReady = false
      this.items = []
      let uc = ""
      if (this.userData.userCode) { uc = '&userCode=' + this.userData.userCode }
      axios
        .get(
          // eslint-disable-next-line quotes
          'https://licm-cargo.com/api/Deliver_detail/Deliver_detail_list?userName=' +
          this.userData.userName +
          '&userType=' +
          this.userData.userType +
          uc +
          '&status=อนุมัติการสั่งออก',
          {
            headers: this.getHeaderAPI('Deliver_detail_list', this.userData.userName)
          }
        )
        .then((response) => {
          // console.log('getDataInvoices', response.data)

          let rs = response.data
          if (rs.status === true){
            if (rs.data.length > 0) {
              // this.totalRows = rs.data.length
              for (let i = 0; i < rs.data.length; i++) {
                let invoiceData = rs.data[i]

                // invoiceData.createDatetime = this.formatDateTime(rs.data[i].CREATE_DATE)
                // invoiceData.lastDatetime = this.formatDateTime(rs.data[i].LAST_DATE)

                this.items.push(invoiceData)
              }
            }
          }

          this.dataReady = true
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          console.log('getDataInvoices error:', error)
          this.dataReady = true
          this.items = []
        });
    },
    getFileBase64 (file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.readAsDataURL(file)
        reader.onload = () => resolve(reader.result)
        reader.onerror = error => reject(error)
      })
    },
    async uploadFile () {
      if (this.fileimg) {
        await this.getFileBase64(this.fileimg)
          .then(picBase64 => {
            // console.log('uploadFile Base64', picBase64)
            this.form.pictureSlip = picBase64
          })
      }
    },
    onInvoiceSelected (invoice) {
      // let dataInvice = invoice[0]
      console.log("onInvoiceSelected", invoice)
      if (invoice.length > 0) {
        this.form.deliverDoc = invoice[0].deliverDoc
        this.priceDelivery = parseFloat(invoice[0].amountDelivery)
      } else {
        this.form.deliverDoc = ''
      }
    },
    onSubmit () {
      console.log("onSubmit Data:", this.form)
      this.dataReady = false
      axios
        .post(
          // eslint-disable-next-line quotes
          "https://licm-cargo.com/api/Deliver_detail/Deliver_detail_update_slip",
          this.form,
          {
            headers: this.getHeaderAPI('Deliver_detail_update_slip', this.form.userName)
          }
        )
        .then(async (response) => {
          console.log('onSubmit', response)
          let rs = response.data
          if (rs.status === true) {
            this.$swal("สำเร็จ","อัพเดตบิลขนส่งเรียบร้อย","success")
              .then((result) => {
                this.$router.push('/Route?target=Transport&uriType=Admin')
              })
            this.dataReady = true
          } else {
            console.log('onSubmit Fail')
            this.$swal("ผิดพลาด","ไม่สามารถอัพเดตบิลขนส่งได้","error")
            this.dataReady = true
          }
        })
        .catch((error) => {
          console.log(error.response)
          this.$swal("Error Update","ไม่สามารถอัพเดตบิลขนส่งได้","error")
          this.dataReady = true
        })
    }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#form-profile {
  text-align: left;
}

.py-75{
  padding-top: .75rem !important;
  padding-bottom: .75rem !important;
}

.ex-card{
  border-style: dotted;
  border-width: 2px;
}

.ex-card > .card-body {
  padding: .75rem;
}

.dropdown-menu {
  min-width: 5rem !important;
  /* text-align: center; */
}
</style>



// WEBPACK FOOTER //
// src/components/PreOrder/OrderTransport.vue